(function () {
  function reveal(root) {
    if (!root || root.dataset.ufAboutMotion === 'ready') return;
    root.dataset.ufAboutMotion = 'ready';
    var items = root.querySelectorAll('.uf-story-path, .uf-future-visual');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('uf-inview'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('uf-inview');
          observer.unobserve(entry.target);
        }
      });
    }, {rootMargin: '0px 0px -10% 0px', threshold: 0.15});
    items.forEach(function (item) { observer.observe(item); });
  }
  function init() {
    document.querySelectorAll('.uf-about').forEach(reveal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
}());
